import React from "react";
import { ClipLoader } from "react-spinners";

function Loader({ color = "#0068b7", size = 30 }) {
    return (
        <span className="loading">
            <ClipLoader color={color} size={size} />
        </span>
    );
}

export default Loader;